/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
} from './CriteriaQualifier';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';

/**
 * 
 * @export
 * @interface OverrideAnalysisResult200ResponseData
 */
export interface OverrideAnalysisResult200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    screener_analysis_result_id: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    created_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    override_criteria_result: OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    override_reason: OverrideAnalysisResult200ResponseDataOverrideReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    override_comment: string;
    /**
     * 
     * @type {CriteriaQualifier}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     * @type {boolean}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    is_medication_rule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    is_revert: boolean;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    updatedAt?: string;
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser}
     * @memberof OverrideAnalysisResult200ResponseData
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
}


/**
 * @export
 */
export const OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A'
} as const;
export type OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum = typeof OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum[keyof typeof OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum];

/**
 * @export
 */
export const OverrideAnalysisResult200ResponseDataOverrideReasonEnum = {
    IncompleteOrMissingPatientData: 'Incomplete or missing patient data',
    NewInformationReceived: 'New information received',
    AiReasoningIssues: 'AI reasoning issues',
    AiExtractionOrReadingError: 'AI extraction or reading error',
    ClinicalJudgmentDiffers: 'Clinical judgment differs'
} as const;
export type OverrideAnalysisResult200ResponseDataOverrideReasonEnum = typeof OverrideAnalysisResult200ResponseDataOverrideReasonEnum[keyof typeof OverrideAnalysisResult200ResponseDataOverrideReasonEnum];


/**
 * Check if a given object implements the OverrideAnalysisResult200ResponseData interface.
 */
export function instanceOfOverrideAnalysisResult200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "screener_analysis_result_id" in value;
    isInstance = isInstance && "created_by_user_id" in value;
    isInstance = isInstance && "override_criteria_result" in value;
    isInstance = isInstance && "override_reason" in value;
    isInstance = isInstance && "override_comment" in value;
    isInstance = isInstance && "qualifier" in value;
    isInstance = isInstance && "is_medication_rule" in value;
    isInstance = isInstance && "is_revert" in value;

    return isInstance;
}

export function OverrideAnalysisResult200ResponseDataFromJSON(json: any): OverrideAnalysisResult200ResponseData {
    return OverrideAnalysisResult200ResponseDataFromJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResult200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'screener_analysis_result_id': json['screener_analysis_result_id'],
        'created_by_user_id': json['created_by_user_id'],
        'override_criteria_result': json['override_criteria_result'],
        'override_reason': json['override_reason'],
        'override_comment': json['override_comment'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': json['is_medication_rule'],
        'is_revert': json['is_revert'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
    };
}

export function OverrideAnalysisResult200ResponseDataToJSON(value?: OverrideAnalysisResult200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organization_id,
        'screener_analysis_result_id': value.screener_analysis_result_id,
        'created_by_user_id': value.created_by_user_id,
        'override_criteria_result': value.override_criteria_result,
        'override_reason': value.override_reason,
        'override_comment': value.override_comment,
        'qualifier': CriteriaQualifierToJSON(value.qualifier),
        'is_medication_rule': value.is_medication_rule,
        'is_revert': value.is_revert,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value.created_by_user),
    };
}

